import { AdminUser, me } from "apis/auth.api";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ServerState } from "utils/serverState";

export const useMe = () =>
  useQuery<AdminUser, AxiosError>(ServerState.ADMIN_USER, () => me());
